import { render, staticRenderFns } from "./EditHolidayPeriod.vue?vue&type=template&id=7248369a"
import script from "./EditHolidayPeriod.vue?vue&type=script&lang=js"
export * from "./EditHolidayPeriod.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports